import { useCostLinesStore } from "entities/CostLines/store/useCostLinesStore";
import { useRequestLinesStore } from "entities/TravelLines";
import { REQUEST_STATUSES, REQUEST_TYPES, ROLES } from "shared/config";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

export const useRequestStore = create()(
  devtools((set, get) => ({
    request: null,
    requestBasicDetailsToUpdate: null,
    setRequestBasicDetailsToUpdate: (requestBasicDetailsToUpdate) =>
      set({ requestBasicDetailsToUpdate }),
    a1DataToSave: null,
    setA1DataToSave: (a1DataToSave) => set({ a1DataToSave }),
    estimatedTravelCostsToSave: null,
    setEstimatedTravelCostsToSave: (estimatedTravelCostsToSave) =>
      set({ estimatedTravelCostsToSave }),
    isEstimatedTravelCostsFormModified: false,
    setIsEstimatedTravelCostsFormModified: (
      isEstimatedTravelCostsFormModified
    ) => set({ isEstimatedTravelCostsFormModified }),
    estimatedEmissionToSave: null,
    setEstimatedEmissionToSave: (estimatedEmissionToSave) =>
      set({ estimatedEmissionToSave }),
    setIsEstimatedEmissionFormModified: (isEstimatedEmissionFormModified) =>
      set({ isEstimatedEmissionFormModified }),
    setMaxCostLinesCount: (maxCostLinesCount) => set({ maxCostLinesCount }),
    setRequest: (request, userRole) => {
      set({ request });
      if (request) {
        const { cost_lines, travel_intervals, ...requestData } = request;

        const costLinesStore = useCostLinesStore.getState();
        const requestLinesStore = useRequestLinesStore.getState();

        costLinesStore.setCostLines(cost_lines?.data ?? []);
        requestLinesStore.setTravelLines(travel_intervals?.data ?? []);

        if (
          requestData?.type === REQUEST_TYPES.TRAVEL &&
          userRole === ROLES.USER
        ) {
          if (!travel_intervals.data.length)
            requestLinesStore.addTravelLine("travel_line");
        }
        if (
          requestData?.type === REQUEST_TYPES.EXPENSE &&
          !cost_lines?.data?.length &&
          userRole === ROLES.USER
        ) {
          if (
            requestData.advance_payments.data.length &&
            requestData.status !== REQUEST_STATUSES.AWAITING_USER_SETTLEMENT
          )
            return;
          costLinesStore.addCostLine();
        }
      }
    },
    updateBasicDetails: ({
      cost_lines,
      travel_intervals,
      acceptations,
      travel_declarations,
      ...basicDetails
    }) =>
      set((state) => ({
        request: {
          ...state.request,
          ...basicDetails,
        },
      })),
    updateRequest: ({ cost_lines, ...newData }) => {
      set((state) => ({
        request: {
          ...state.request,
          ...newData,
        },
      }));
    },
    updateRequestA1Data: (a1Data) => {
      set((state) => ({
        request: {
          ...state.request,
          aone_data: a1Data,
        },
      }));
    },

    splitCardRequestCost: (transactionId, insertIndex, splittedCost) => {
      set((state) => {
        return {
          request: {
            ...state.request,
            credit_cards_costs_transactions: {
              data: state.request.credit_cards_costs_transactions.data.map(
                (transaction) => {
                  if (transaction.id === transactionId) {
                    return {
                      ...transaction,
                      credit_cards_costs_transaction_sub_costs: {
                        data: [
                          ...transaction.credit_cards_costs_transaction_sub_costs.data.slice(
                            0,
                            insertIndex
                          ),
                          splittedCost,
                          ...transaction.credit_cards_costs_transaction_sub_costs.data.slice(
                            insertIndex
                          ),
                        ],
                      },
                    };
                  } else return transaction;
                }
              ),
            },
          },
        };
      });
    },
    removeSplittedCardRequestCost: (transactionId, subCostId) =>
      set((state) => {
        const targetTransaction =
          state.request.credit_cards_costs_transactions.data.filter(
            (transaction) => transaction.id === transactionId
          )[0];
        const updatedSubCosts =
          targetTransaction.credit_cards_costs_transaction_sub_costs.data.filter(
            (cost) => cost.id !== subCostId
          );

        return {
          request: {
            ...state.request,
            credit_cards_costs_transactions: {
              data: state.request.credit_cards_costs_transactions.data.map(
                (transaction) => {
                  if (transaction.id === transactionId) {
                    return {
                      ...transaction,
                      credit_cards_costs_transaction_sub_costs: {
                        data: updatedSubCosts,
                      },
                    };
                  } else return transaction;
                }
              ),
            },
          },
        };
      }),
  }))
);
